import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'


import HOW from '@/components/How'
import WPP from '@/components/WPP'
import TANDCS from '@/components/TANDCS'

import GoogleMap from '@/components/GoogleMap'
import About from '@/components/About'
import BusinessSelect from '@/components/BusinessSelect'
import Login from '@/components/Login'
import Profile from '@/components/Profile'
import Admin from '@/components/admin/Admin'
import AdminBusinessProjects from '@/components/admin/AdminBusinessProjects'
import AdminBusinessLinks from '@/components/admin/AdminBusinessLinks'

import AdminCommon from '@/components/admin/AdminCommon'
import AdminStoreStaffGroups from '@/components/admin/AdminStoreStaffGroups'

import AdminCustomersRemedialsProcessing from '@/components/admin/customerremedials/AdminCustomersRemedialsProcessing'
import AdminCustomersRemedialsDeclined from '@/components/admin/customerremedials/AdminCustomersRemedialsDeclined'

import AdminCustomersRemedialsHome from '@/components/admin/customerremedials/AdminCustomersRemedialsHome'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Default',
      component: Home,
      meta:{
        title:'Home'
      }
    },    
    {
      path: '/admin/home',
      name: 'Admin',
      component: Admin,
      meta:{
        title:'Admin'
      }
      
    },      
    {
      path: '/admin/customerremedials/home',
      name: 'AdminCustomersRemedialsHome',
      component: AdminCustomersRemedialsHome,
      meta:{
        title:'Remedials'
      }
    },     
    {
      path: '/admin/customerremedials/processing',
      name: 'AdminRemedialsProcessing',
      component: AdminCustomersRemedialsProcessing,
      meta:{
        title:'Process'
      }
    },     
    {
      path: '/admin/customerremedials/declined',
      name: 'AdminCustomersRemedialsDeclined',
      component: AdminCustomersRemedialsDeclined,
      meta:{
        title:'Declined'
      }
    }, 
    
    
   
    {
      path: '/admin/common',
      name: 'AdminCommon',
      component: AdminCommon,
      meta:{
        title:'Common'
      }
    }, 
    
    {
      path: '/admin/projects',
      name: 'AdminBusinessProjects',
      component: AdminBusinessProjects,
      meta:{
        title:'Projects'
      }
    },  
    {
      path: '/admin/businesslinks',
      name: 'AdminBusinessLinks',
      component: AdminBusinessLinks,
      meta:{
        title:'BusinessLinks'
      }
    },  
    
    {
      path: '/admin/staff',
      name: 'AdminStoreStaffGroups',
      component: AdminStoreStaffGroups,
      meta:{
        title:'Staff'
      }
    },
    
    {
      path: '/googlemap',
      name: 'GoogleMap',
      component: GoogleMap
    },  
   
    
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta:{
        title:'Home'
      }
    },      
    {
      path: '/how',
      name: 'how',
      component: HOW,
      meta:{
        title:'How to Links'
      }
    },   
    {
      path: '/wpp',
      name: 'WPP',
      component: WPP,
      meta:{
        title:'Privacy Policy'
      }
    },   
    {
      path: '/termsconditions',
      name: 'TANDCS',
      component: TANDCS,
      meta:{
        title:'Terms of use'
      }
    },   
    
    
    {
      path: '/about',
      name: 'About',
      component: About,
      meta:{
        title:'About'
      }
    },
    
    {
      path: '/businessselect',
      name: 'BusinessSelect',
      component: BusinessSelect,
      meta:{
        title:'Shops'
      }
    },
    
 
   
    // {
    //   path: '/offers/:id',
    //   name: 'Offers',
    //   component: Offers
    // },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta:{
        title:'Login'
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta:{
        title:'My Profile'
      }
    }

    
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js